/**
 * Test IDs for QA automation.
 */
export const testIds = {
  storageFacilitySelectControl: "storage-facility-select-control",
  storageFacilitySelectFacilityOption: "storage-facility-select-facility-option",
} as const;
